import React, { Component } from 'react'

export default class IconStop extends Component<any> {
    render() {
        return (
            <div onClick={this.props.onClick} className={this.props.className}>
                <span style={{ color: (this.props.color || '#000') }} className="icon-stop"></span>
            </div>
        )
    }
}